import { styled } from '@mui/system';
import { COLORS } from '../../../../../../../common/Styleguide/Common/colors';
import theme from '../../../../../../../components/App/theme';

export const SubmissionOverviewHeaderContainer = styled('div')({
  position: 'relative',
  backgroundColor: COLORS.black[70],
  padding: 30,
  borderRadius: 20,
  display: 'flex',
  flexDirection: 'column',
  rowGap: 18,
  '& > div:first-child': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    '& > div:first-child': {
      display: 'flex',
      flexDirection: 'column',
      rowGap: 18,
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        columnGap: 18,
      },
    },
    '& > div:last-child': {
      position: 'absolute',
      right: 30,
      [theme.breakpoints.up('md')]: {
        position: 'relative',
        right: 0,
      },
    },
  },
  '& > div:last-child': {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 18,
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
    },
    '& > div:first-child': {
      alignSelf: 'flex-start',
    },
    '& > div:last-child': {
      alignSelf: 'flex-start',
      [theme.breakpoints.up('md')]: {
        alignSelf: 'flex-end',
        rowGap: 8,
      },
    },
  },
});

export const SubmissionOverviewHeaderCoverImg = styled('div')({
  '& > img': {
    display: 'block',
    width: 138,
    height: 78,
    borderRadius: 10,
  },
});

export const SubmissionOverviewHeaderTitle = styled('div')({
  fontSize: 32,
  color: COLORS.white[100],
  lineHeight: 1.35,
  fontWeight: 700,
});

export const SubmissionOverviewHeaderBadges = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  marginTop: 8,
  columnGap: 12,
});

export const SubmissionOverviewHeaderMetadata = styled('div')({
  color: COLORS.white[40],
  fontSize: 16,
  lineHeight: 1.35,
  '& > span': {
    fontWeight: 700,
  },
});
